export type GoalValue =
  | "AGGRESSIVE_CUT"
  | "CUT"
  | "MODERATE_CUT"
  | "SHORT_CUT"
  | "MAINTENANCE"
  | "MODERATE_BULK"
  | "BULK"
  | "AGGRESSIVE_BULK";

export interface GoalType {
  name: string;
  value: GoalValue;
  trend: -1 | 0 | 1;
}

export const GoalTypes: GoalType[] = [
  {
    name: "חיטוב אגרסיבי",
    value: "AGGRESSIVE_CUT",
    trend: -1,
  },
  {
    name: "חיטוב",
    value: "CUT",
    trend: -1,
  },
  {
    name: "חיטוב מתון",
    value: "MODERATE_CUT",
    trend: -1,
  },
  {
    name: "חיטוב קצר",
    value: "SHORT_CUT",
    trend: -1,
  },
  {
    name: "ריקומפ",
    value: "MAINTENANCE",
    trend: 0,
  },
  {
    name: "מסה מתונה",
    value: "MODERATE_BULK",
    trend: 1,
  },
  {
    name: "מסה",
    value: "BULK",
    trend: 1,
  },
  {
    name: "מסה אגרסיבית",
    value: "AGGRESSIVE_BULK",
    trend: 1,
  },
]

// Default weekly range (WeeklyRanges value) auto-selected when a goal is chosen.
export const GOAL_DEFAULT_WEEKLY_RANGE: Record<GoalValue, string> = {
  AGGRESSIVE_CUT: "X_LARGE_MINUS",  // -0.7 to -1
  CUT: "MEDIUM_MINUS",              // -0.3 to -0.5
  MODERATE_CUT: "SMALL_MINUS",      // -0.2 to -0.4
  SHORT_CUT: "X_MEDIUM_MINUS",      // -0.4 to -0.6
  MAINTENANCE: "MAINTENANCE",       // -0.2 to +0.2
  MODERATE_BULK: "X_SMALL_PLUS",    // +0.1 to +0.3
  BULK: "SMALL_PLUS",               // +0.2 to +0.4
  AGGRESSIVE_BULK: "X_MEDIUM_PLUS", // +0.4 to +0.6
}
